"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userAppsState = exports.lookerAuthenticatedState = exports.portalAuthenticatedState = exports.currentApp = exports.accessTokenExpiry = exports.refreshTokenExpiry = exports.refreshToken = exports.authorizationToken = void 0;
exports.default = PrivateRoute;
const hooks_1 = require("@alcumus/hooks");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const recoil_1 = require("recoil");
const auth_1 = require("../../../server/models/auth");
const looker_account_1 = require("../../../server/models/looker-account");
const LoadingPage_1 = __importDefault(require("../LoadingPage/LoadingPage"));
exports.authorizationToken = (0, recoil_1.atom)({
    key: 'authorizationToken',
    default: '',
});
exports.refreshToken = (0, recoil_1.atom)({
    key: 'refreshToken',
    default: '',
});
exports.refreshTokenExpiry = (0, recoil_1.atom)({
    key: 'refreshTokenExpiry',
    default: '',
});
exports.accessTokenExpiry = (0, recoil_1.atom)({
    key: 'accessTokenExpiry',
    default: '',
});
exports.currentApp = (0, recoil_1.atom)({
    key: 'currentApp',
    default: '',
});
exports.portalAuthenticatedState = (0, recoil_1.atom)({
    key: 'portalAuthenticatedState',
    default: false,
});
exports.lookerAuthenticatedState = (0, recoil_1.atom)({
    key: 'lookerAuthenticatedState',
    default: false,
});
exports.userAppsState = (0, recoil_1.atom)({
    key: 'userAppsState',
    default: [],
});
function PrivateRoute({ path, exact, route, }) {
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [isLookerAuthenticated, setIsLookerAuthenticated] = (0, recoil_1.useRecoilState)(exports.lookerAuthenticatedState);
    const tokenRefreshInterval = 1 * 60 * 1000;
    const [app, setApp] = (0, recoil_1.useRecoilState)(exports.currentApp);
    const [isPortalAuthenticating, setIsPortalAuthenticating] = (0, react_1.useState)(false);
    const [portalToken, setPortalToken] = (0, recoil_1.useRecoilState)(exports.authorizationToken);
    const [refToken, setRefreshToken] = (0, recoil_1.useRecoilState)(exports.refreshToken);
    const [refTokenExpiry, setRefTokenExpiry] = (0, recoil_1.useRecoilState)(exports.refreshTokenExpiry);
    const [accTokExpiry, setAccTokenExpiry] = (0, recoil_1.useRecoilState)(exports.accessTokenExpiry);
    const [, setApps] = (0, recoil_1.useRecoilState)(exports.userAppsState);
    const handleErrors = () => {
        setIsLookerAuthenticated(false);
        setIsLoading(false);
    };
    const getPortalAccess = (0, react_1.useCallback)(async () => {
        const result = await (0, looker_account_1.initializePortalToken)();
        if (result === looker_account_1.PortalAuthenticationTypes.Authenticated) {
            getUserApps();
        }
        else if (result === looker_account_1.PortalAuthenticationTypes.IsAuthenticating) {
            setIsPortalAuthenticating(true);
        }
        else {
            handleErrors();
        }
    }, []);
    const getLookerAccess = (0, react_1.useCallback)(async () => {
        const result = await (0, looker_account_1.hasLookerAccess)();
        setIsLookerAuthenticated(result);
        setIsLoading(false);
    }, []);
    (0, hooks_1.useInterval)(() => {
        const refreshToken = localStorage.getItem('refreshToken');
        const accessToken = localStorage.getItem('accessToken');
        if (refreshToken && accessToken) {
            (0, auth_1.refresh)(refreshToken, accessToken);
        }
    }, tokenRefreshInterval);
    (0, react_1.useEffect)(() => {
        if (portalToken === '' || portalToken === undefined) {
            getPortalAccess();
        }
        else {
            localStorage.setItem('accessToken', portalToken);
            localStorage.setItem('refreshToken', refToken);
            localStorage.setItem('expiresIn', accTokExpiry);
            setPortalToken('');
            setAccTokenExpiry('');
            setRefTokenExpiry('');
            setRefreshToken('');
        }
    }, [portalToken]);
    const getUserApps = (0, react_1.useCallback)(async () => {
        (0, looker_account_1.getApplicationAccessDetails)()
            .then((response) => {
            const localStorageApp = localStorage.getItem('application_id');
            if (localStorageApp &&
                response.findIndex((x) => x.appId === localStorageApp) > -1) {
                setApp(localStorageApp);
            }
            else {
                const [defaultApp] = response;
                localStorage.setItem('application_id', defaultApp.appId);
                setApp(defaultApp.appId);
            }
            setApps(response);
        })
            .catch(() => {
            setIsLookerAuthenticated(false);
            setIsLoading(false);
        });
    }, []);
    (0, react_1.useEffect)(() => {
        if (app !== '') {
            setIsLoading(true);
            setIsLookerAuthenticated(false);
            getLookerAccess();
        }
    }, [app]);
    return (react_1.default.createElement(react_router_dom_1.Route, { path: path, exact: exact, render: (props) => {
            return isLoading || isPortalAuthenticating ? (react_1.default.createElement(LoadingPage_1.default, null)) : isLookerAuthenticated ? (react_1.default.createElement(react_1.default.Fragment, null, route.component && react_1.default.createElement(route.component, { ...props }))) : (react_1.default.createElement(react_router_dom_1.Redirect, { to: "/unauthorized" }));
        } }));
}
